import { GET_KOTA, SET_LOADING_KOTA, SET_PAGINATION_KOTA } from '../constant';

const initialState = {
  kota: [],
  kotaPagination: 0,
  loadingKota: false,
  totalKota: 0,
};

const kotaReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_KOTA: {
      return {
        ...state,
        loadingKota: action?.payload,
      };
    }
    case SET_PAGINATION_KOTA: {
      return {
        ...state,
        kotaPagination: action?.payload,
      };
    }
    case GET_KOTA: {
      return {
        ...state,
        kota: action?.payload?.data || [],
        totalKota: action?.payload?.total,
        loadingKota: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default kotaReducer;
